"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonComponent = void 0;
const BaseComponent_1 = require("./BaseComponent");
/**
 * 按钮组件
 * 提供可点击的按钮功能
 */
class ButtonComponent extends BaseComponent_1.BaseComponent {
    constructor(text, onClick, container) {
        super(container);
        this.clickCallbacks = [];
        this._text = text;
        if (onClick) {
            this.clickCallbacks.push(onClick);
        }
        BaseComponent_1.NexusGUIManager.registerComponent(this);
    }
    /**
     * 获取/设置按钮文本
     */
    get text() {
        return this._text;
    }
    set text(v) {
        this._text = v;
        this.buttonElement.textContent = v;
    }
    /**
     * 注册点击事件回调
     */
    onClick(callback) {
        this.clickCallbacks.push(callback);
    }
    /**
     * 移除点击事件回调
     */
    removeOnClick(callback) {
        const index = this.clickCallbacks.indexOf(callback);
        if (index > -1) {
            this.clickCallbacks.splice(index, 1);
        }
    }
    /**
     * 清空所有点击事件回调
     */
    clearOnClick() {
        this.clickCallbacks = [];
    }
    /**
     * 触发点击事件
     */
    click() {
        if (this.enabled) {
            this.notifyClick();
        }
    }
    createElement() {
        this.buttonElement = document.createElement('button');
        this.element = this.buttonElement;
    }
    render() {
        // 设置样式类
        this.buttonElement.className = 'nexus-button';
        this.buttonElement.textContent = this._text;
        // 添加到容器
        this.container.appendChild(this.buttonElement);
    }
    bindEvents() {
        this.buttonElement.addEventListener('click', (e) => {
            e.preventDefault();
            if (this.enabled) {
                this.notifyClick();
            }
        });
    }
    notifyClick() {
        this.clickCallbacks.forEach(callback => {
            try {
                callback();
            }
            catch (error) {
                console.error('Error in button click callback:', error);
            }
        });
    }
    updateEnabledState() {
        super.updateEnabledState();
        if (this.buttonElement) {
            this.buttonElement.disabled = !this.enabled;
        }
    }
}
exports.ButtonComponent = ButtonComponent;
